import { gql } from 'apollo-angular'

export default gql`
  mutation testStudy(
    $studyId: Int!
    $userId: Int!
    $routineId: Int!
    $version: String
  ) {
    testStudy(
      data: {
        studyId: $studyId
        userId: $userId
        phantomTestRoutineId: $routineId
        version: $version
      }
    ) {
      id
    }
  }
`
